import React from 'react';
import { useRef } from 'react';
import { motion, useCycle } from 'framer-motion';
import { MenuToggle } from './MenuToggle';
import Logo from './Logo';
import styled from 'styled-components';
import SocialShare from '../social/SocialShare';
import theme from '../../theme';
import responsive, { breakpoint } from '../../utils/responsive';
import Navigation from './Navigation';

const nav = {
  open: {
    pointerEvents: 'all',
    // clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
    background: '#fff',
    width: '18.75rem',
    opacity: 1,
    transition: {
      stiffness: 30,
      velocity: 5,
    },
  },
  closed: {
    pointerEvents: 'none',
    width: '4rem',
    // clipPath: 'circle(30px at 40px 40px)',
    opacity: 1,
    background: 'rgba(255, 255, 255, 0)',
    transition: {
      delay: 0.4,
      stiffness: 400,
      damping: 40,
    },
  },
};

const share = {
  open: {
    height: '6em',
  },
  closed: {
    height: 'auto',
  },
};

const toggle = {
  open: {
    backgroundColor: theme.colors.primary.toHex(),
    clipPath: 'circle(300px at 30px 21px',
  },
  closed: ({ small }) => ({
    backgroundColor: theme.colors.primary.alpha(0.7).toHex(),
    clipPath: small ? 'circle(20px at 30px 25px)' : 'circle(25px at 31px 29px)',
    transition: {
      stiffness: 30,
      delay: 0.4,
    },
  }),
};

const Header = styled(motion.div)`
  display: flex;
  background: ${theme.colors.primary.toHex()};
  align-items: center;
  padding-left: 0.8rem;
  height: 4rem;
  flex: 1 0 auto;
  max-height: 4rem;

  ${responsive.md.andSmaller`
    flex: 1 0 auto;
    height: 3.5rem;
    max-height: 3.5rem;
  `};
`;

const Nav = styled(motion.nav)`
  position: fixed;
  top: 0;
  left: 0;
  width: 18.75rem;
  max-width: 70%;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: start !important;
  background: #fff;
  height: 100vh;
`;

const Buttons = styled(motion.div)`
  display: flex;
  align-items: center;
  margin-left: 1em;
  margin-right: auto;

  > * {
    margin-bottom: 1em;
  }
`;

export const Navbar = () => {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const containerRef = useRef(null);
  return (
    <Nav
      initial={false}
      animate={isOpen ? 'open' : 'closed'}
      ref={containerRef}
      variants={nav}
    >
      <Header
        variants={toggle}
        custom={{ small: window.innerWidth < breakpoint.md }}
      >
        <MenuToggle toggle={() => toggleOpen()} />
        <Logo />
      </Header>

      <Buttons variants={share}>
        <SocialShare isOpen={isOpen} />
      </Buttons>
      <Navigation onClick={toggleOpen} />
    </Nav>
  );
};
